module.exports = __webpack_public_path__ + "static/media/milleBoards.610398f4.png";